import styled from "styled-components";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";

import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import Button from "@/components/Button";
import PreProductionTable from "./components/PreProductionTable";
import ProjectModal from "./components/ProjectModal";

const HeadingRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const PreProduction = () => {
  const [showProjectModal, setShowProjectModal] = useState(false);

  return (
    <>
      <TeamHeading />
      <HeadingRow>
        <PageHeading>Pre-Production</PageHeading>
        <Button onClick={() => setShowProjectModal(true)}>New Project</Button>
      </HeadingRow>
      <PreProductionTable />
      <AnimatePresence>
        {showProjectModal && (
          <ProjectModal onClose={() => setShowProjectModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default PreProduction;
